/* Mirrors ticketing-api-2.0/tmp/embed_demo.html, but the live <script src="..."> tag
   that fetches the published embed from api-v2 is replaced with the {{EMBED_SCRIPT}}
   placeholder so the editor can inject the *current draft's* minified output. */
export const embedDemoHtml = `<!doctype html>
<html>
	<head>
		<meta charset="UTF-8" />
		<title>Embed Demo</title>
		<style>
			body { font-family: -apple-system, sans-serif; padding: 24px; color: #333; }
			.tixologi-button { padding: 10px 18px; font-size: 14px; cursor: pointer; }
		</style>
	</head>
	<body>
		<h1>Embed Demo</h1>
		<button data-event-id="11389" class="tixologi-button">Buy Tickets</button>
		<script>
			try {
				{{EMBED_SCRIPT}}
			} catch (e) {
				document.body.insertAdjacentHTML(
					'beforeend',
					'<pre style="color:#c0392b">' + (e && e.stack ? e.stack : e) + '</pre>'
				);
			}
		</script>
	</body>
</html>`;
